/**
 * Shared formatting utilities.
 */

/** Format a dollar cost with adaptive precision — always shows sub-cent detail. */
export function formatCost(cost: number): string {
  if (cost < 0.001) return `$${cost.toFixed(6)}`;
  if (cost < 0.01) return `$${cost.toFixed(4)}`;
  if (cost < 1) return `$${cost.toFixed(4)}`;
  return `$${cost.toFixed(2)}`;
}

/** Format a per-1M-token price with adaptive precision. */
export function formatPricePer1M(v: number): string {
  if (v < 0.01) return v.toFixed(4);
  if (v < 1) return v.toFixed(3);
  return v.toFixed(2);
}
